const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Asignar insumos a un edificio
 */
export const assignInsumosToEdificio = async (edificioId, insumoIds) => {
  try {
    const response = await fetch(`${API_URL}/edificios/assign-insumos`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        edificioId,
        insumoIds,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Error al asignar insumos');
    }

    return data;
  } catch (error) {
    console.error('Error en assignInsumosToEdificio:', error);
    throw error;
  }
};

/**
 * Obtener insumos asignados a un edificio
 */
export const getEdificioInsumos = async (edificioId) => {
  try {
    const response = await fetch(`${API_URL}/edificios/${edificioId}/insumos`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Error al obtener insumos');
    }

    return data;
  } catch (error) {
    console.error('Error en getEdificioInsumos:', error);
    throw error;
  }
};
